/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Invoice receive email process type / 請求書の保存場所
 */
export type GetApPayeeInfoResponseInvoiceReceiveEmailProcessType =
  (typeof GetApPayeeInfoResponseInvoiceReceiveEmailProcessType)[keyof typeof GetApPayeeInfoResponseInvoiceReceiveEmailProcessType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApPayeeInfoResponseInvoiceReceiveEmailProcessType = {
  payment_request: 'payment_request',
  received_invoice: 'received_invoice',
} as const;
